import React,{Component} from 'react';
import Button from '@react/react-spectrum/Button';
import ModalTrigger from '@react/react-spectrum/ModalTrigger';
import CustomRejectDialog from './CustomRejectDialog';
import {withTranslation } from 'react-i18next';
import {connect} from "react-redux";
import {rejectRequest,setSelectedReason} from "../../actions/ApproveRejectActions";
import * as appConstants from '../../constants/AppConstants';

export class RejectModal extends Component{
    constructor(props){
        super(props);
        this.confirm = this.confirm.bind(this);
        this.setSelectionReason = this.setSelectionReason.bind(this); 
    }

    confirm(){
        if (this.shouldSkipConfirmationDialog()) {
            this.setDefaultRejectReason();
        }
        this.props.rejectRequest(this.props.approveId);
    }

    setSelectionReason(selectedReason){
        this.props.setSelectedReason(selectedReason)
    }

    shouldSkipConfirmationDialog() {
        return this.props.workFlowType === appConstants.CHANGE_PRIMARY_ADMIN;
    }

    setDefaultRejectReason() {
        const { rejectReasons } = this.props;
        if (rejectReasons && rejectReasons.length) {
            this.props.setSelectedReason(rejectReasons[0].value);
        }
    }

    render(){
        if (this.shouldSkipConfirmationDialog()) {
            return (
                <Button
                    label={this.props.btnLabel}
                    variant={this.props.variant}
                    onClick={this.confirm}
                    data-am-id="rejectModalBtn"
                    data-approval-id={this.props.approveId}
                />
            );
        }

        return(
            <ModalTrigger>
                <Button label={this.props.btnLabel} variant={this.props.variant} modalTrigger data-am-id="rejectModalBtn" data-approval-id={this.props.approveId}/>
                <CustomRejectDialog rejectReasons={this.props.rejectReasons} setSelectedReason={this.setSelectionReason} workFlowType={this.props.workFlowType} confirm={this.confirm} backdropClickable/>
            </ModalTrigger>
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        rejectReasons:state.AppReducer.rejectedReasons
    }
};

const mapDispatchToProps = (dispatch)=>{
    return{
        rejectRequest : (approvalId) => dispatch(rejectRequest(approvalId)),
        setSelectedReason : (selectedReason) => dispatch(setSelectedReason(selectedReason))
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(RejectModal));

